/**
 * Chummys occasions — the desk and the postcards.
 *  - bands reveal as they arrive
 *  - the sheet of stamps: hovering (or focusing) a stamp makes it the active
 *    one; the card on the desk rewrites its line for that occasion and the
 *    button under it points at that moment. Clicking scrolls there.
 *  - every card line is written out in handwriting as its band comes in
 */
(() => {
  if (window.__chummysOs) return;
  window.__chummysOs = true;
  const boot = (root) => {
  if (!root || root.dataset.osBound) return;
  root.dataset.osBound = '1';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* handwriting: type the line, letter by letter, with a small human wobble */
  const writers = new WeakMap();
  const write = (el, text) => {
    const value = text != null ? text : (el.dataset.text || el.textContent);
    const prev = writers.get(el); if (prev) clearTimeout(prev.t);
    if (reduced) { el.textContent = value; el.classList.remove('is-writing'); return; }
    const state = { t: 0 }; writers.set(el, state);
    el.textContent = ''; el.classList.add('is-writing');
    let i = 0;
    const step = () => {
      i += 1; el.textContent = value.slice(0, i);
      if (i < value.length) { const ch = value[i - 1]; state.t = setTimeout(step, /[.,!?]/.test(ch) ? 220 : 26 + Math.random() * 34); }
      else el.classList.remove('is-writing');
    };
    state.t = setTimeout(step, 180);
  };

  /* reveal */
  const items = Array.from(root.querySelectorAll('[data-reveal]'));
  const arrive = (el) => { el.classList.add('is-in'); el.querySelectorAll('[data-write]').forEach((w) => { if (!w.dataset.written) { w.dataset.written = '1'; write(w); } }); };
  if (reduced || !('IntersectionObserver' in window)) items.forEach(arrive);
  else {
    const io = new IntersectionObserver((entries) => { entries.forEach((e) => { if (e.isIntersecting) { arrive(e.target); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    items.forEach((el) => io.observe(el));
  }

  /* the sheet and the card on the desk */
  const demoLine = root.querySelector('[data-demo-line]');
  const demoCta = root.querySelector('[data-demo-cta]');
  const demoCtaText = root.querySelector('[data-demo-cta-text]');
  const stamps = Array.from(root.querySelectorAll('[data-sheet-stamp]'));
  let active = stamps.find((s) => s.classList.contains('is-active')) || stamps[0];
  const setActive = (stamp) => {
    if (!stamp || stamp === active) return;
    active = stamp;
    stamps.forEach((s) => s.classList.toggle('is-active', s === stamp));
    root.querySelectorAll('[data-demo-stamp-for]').forEach((w) => w.classList.toggle('is-active', w.dataset.demoStampFor === stamp.dataset.key));
    if (demoLine) write(demoLine, stamp.dataset.line || '');
    if (demoCta) { demoCta.setAttribute('href', stamp.getAttribute('href')); if (demoCtaText) demoCtaText.textContent = stamp.dataset.label || demoCtaText.textContent; }
  };
  stamps.forEach((stamp) => {
    stamp.addEventListener('pointerenter', () => setActive(stamp));
    stamp.addEventListener('focus', () => setActive(stamp));
  });

  /* anchors that scroll with the header out of the way */
  root.querySelectorAll('[data-chip]').forEach((chip) => {
    chip.addEventListener('click', (e) => {
      const id = chip.getAttribute('href');
      const target = id && id.startsWith('#') ? document.querySelector(id) : null;
      if (!target) return;
      e.preventDefault();
      if (chip.hasAttribute('data-sheet-stamp')) setActive(chip);
      const head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 84;
      const y = target.getBoundingClientRect().top + window.scrollY - head - 12;
      window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
      history.replaceState(null, '', id);
    });
  });
  };
  document.querySelectorAll('[data-os]').forEach(boot);
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-os]').forEach(boot));
})();
